import { useEffect, useRef, useState } from 'react';
import { setRef } from '../../util/ref-util';
import { postfixTestId } from '../../util/testId';
import { Flow } from '../Layouts/Flow';
import { Popover } from '../Popover';
import cn from './CustomTooltip.css.json';
import './CustomTooltip.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CustomTooltip = props => {
  const [disableFocusLock, setDisableFocusLock] = useState(false);
  const [mouseOpen, setMouseOpen] = useState(false);
  const referenceElementRef = useRef(null);
  const [popoverPosition, setPopoverPosition] = useState();
  const getReferenceElement = element => {
    if (element) {
      if (window.getComputedStyle(element).display === 'contents') {
        return getReferenceElement(element.children?.[0]);
      } else {
        return element;
      }
    }
  };
  const openTimer = useRef(-1);
  const closeTimer = useRef(-1);
  useEffect(() => {
    if (props.isOpen && !mouseOpen) {
      props.initialFocusRef?.current?.focus();
    }
  }, [mouseOpen, props.initialFocusRef, props.isOpen]);
  return /*#__PURE__*/_jsxs("div", {
    className: cn.root,
    onMouseLeave: () => {
      if (openTimer.current > 0) clearTimeout(openTimer.current);
      closeTimer.current = window.setTimeout(() => {
        props.onClose();
        setMouseOpen(false);
        closeTimer.current = -1;
      }, 500);
    },
    onMouseEnter: () => {
      if (closeTimer.current > 0) clearTimeout(closeTimer.current);
    },
    children: [/*#__PURE__*/_jsx("div", {
      className: cn.referenceElementContainer,
      onMouseEnter: () => {
        setMouseOpen(true);
        setDisableFocusLock(true);
        openTimer.current = window.setTimeout(() => {
          openTimer.current = -1;
          (props.title || props.content) && props.onOpen();
        }, 500);
      },
      onMouseMove: e => {
        !props.isOpen && setPopoverPosition({
          bottom: e?.nativeEvent.clientY,
          height: 0,
          left: e?.nativeEvent.clientX,
          right: e?.nativeEvent.clientX,
          top: e?.nativeEvent.clientY,
          width: 0
        });
      },
      onKeyDown: e => {
        if (props.isOpen && e.key === 'Escape') {
          setDisableFocusLock(false);
          props.onClose();
          referenceElementRef.current?.focus();
          setMouseOpen(false);
        }
      },
      onMouseUp: () => {
        if (openTimer.current > 0) clearTimeout(openTimer.current);
        setDisableFocusLock(false);
        props.onClose();
        setMouseOpen(false);
      },
      "data-testid": postfixTestId(props.testId, 'referenceElementContainer'),
      ref: element => {
        setRef(referenceElementRef, getReferenceElement(element?.children[0]));
      },
      children: props.children
    }), /*#__PURE__*/_jsx(Popover, {
      className: cn.basePopover,
      title: props.title,
      focusable: props.popoverFocusable,
      focusLockProps: {
        disabled: props.focusLockProps?.disabled && disableFocusLock,
        ...props.focusLockProps
      },
      isOpen: props.isOpen,
      onClose: () => {
        setDisableFocusLock(true);
        props.onClose();
        setMouseOpen(false);
      },
      hideArrow: props.hideArrow ?? true,
      placement: props.placement ?? 'auto',
      referenceElementRef: mouseOpen ? undefined : referenceElementRef,
      role: "dialog",
      ariaLabel: props.ariaLabel,
      ariaLabelledby: props.ariaLabelledBy,
      ariaDescribedby: props.ariaDescribedBy,
      position: popoverPosition,
      "data-testid": props.testId,
      disableContextMenu: true,
      children: /*#__PURE__*/_jsx(Flow, {
        orientation: "vertical",
        children: props.content
      })
    })]
  });
};
//# sourceMappingURL=CustomTooltip.js.map